import { downloadFile } from '@ibk/shared-utils';
export function downloadBankSlipPdf(bankSlipResult, filename, onError, errorMessage) {
    try {
        const cleanBase64 = bankSlipResult.replace(/^data:application\/pdf;base64,/, '');
        const byteCharacters = atob(cleanBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        downloadFile(filename, 'pdf', [byteArray]);
    }
    catch {
        onError({
            visible: true,
            message: errorMessage,
            type: 'error',
        });
    }
}
export async function copyPaymentCode({ paymentCode, setAlertData, t, translationKey, }) {
    await navigator.clipboard.writeText(paymentCode ?? '');
    setAlertData({
        visible: true,
        message: t(translationKey),
        type: 'success',
    });
}
export async function generatePaymentCode({ contractId, rechargeId, recharge, fetchPaymentCode, setAlertData, t, codeField, generatingKey, generatedKey, notGeneratedKey, }) {
    if (!contractId || !rechargeId || !recharge) {
        return;
    }
    setAlertData({
        visible: true,
        message: t(generatingKey),
        type: 'info',
    });
    try {
        const result = await fetchPaymentCode({
            voucherContractId: contractId,
            voucherContractRechargeId: rechargeId,
        });
        if (result?.[codeField]) {
            setAlertData({
                visible: true,
                message: t(generatedKey),
                type: 'success',
            });
        }
        else {
            throw new Error('Payment code not generated');
        }
    }
    catch {
        setAlertData({
            visible: true,
            message: t(notGeneratedKey),
            type: 'error',
        });
    }
}
export function downloadBankSlip({ contractId, rechargeId, recharge, fetchBankSlip }) {
    if (contractId && rechargeId && recharge) {
        fetchBankSlip({
            voucherContractId: contractId,
            voucherContractRechargeId: rechargeId,
        });
    }
}
